import type { ScheduleModeConfig } from '../types';

/**
 * Bulk self-schedule reuses the single self-schedule's 4-step shape
 * (Details → Slot selection email → Communication → Scorecard).
 *
 * The shape lives in the same `Tabs` chrome as `self-schedule` —
 * what differs from a user's perspective is what comes BEFORE the
 * tabs: a prerequisite overlay that asks for an interview plan and
 * categorises the selected candidates (eligible / no-email /
 * already-scheduled). Once the overlay resolves, this config drives
 * the standard wizard render.
 *
 * Save-time differences (different endpoint + payload shape) live in
 * `useScheduleSave` + `payload/mapBulkSelfScheduleContext.ts`, not here.
 */
export const bulkSelfScheduleModeConfig: ScheduleModeConfig = {
  key: 'bulk-self-schedule',
  navigationStyle: 'tabs',
  steps: [
    { key: 'details', label: 'Details' },
    { key: 'slotSelectionEmail', label: 'Slot selection email' },
    { key: 'communication', label: 'Invites & emails' },
    { key: 'scorecard', label: 'Scorecard' },
  ],
  showSecondaryCta: true,
};
